import React, { useContext, useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import { apiBaseUrl } from "./config/api";
import LandPage from "./components/landPage";
import { More } from "./components/More";
import { Project } from "./components/projectDetails";
import SmoothScroll from "smooth-scroll";
import { AuthContext } from "./context/auth-context";
import axios from "axios";
import { NewDetail } from "./components/NewDetails";
export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});
function App() {
  const [selectedLanguage, setSelectedLanguag] = useState("EN");

  const auth = useContext(AuthContext);
  const changeLanguage = (lang) => {
    setSelectedLanguag(lang);
    localStorage.setItem("lang", lang);
    document.documentElement.dir = lang === "AR" ? "rtl" : "ltr";
  };
  const getUserData = async () => {
    await axios
      .get(
        "https://geolocation-db.com/json/d802faa0-10bd-11ec-b2fe-47a0872c6708"
      )
      .then((respons) => {
        const data = respons.data;

        const formData = JSON.stringify(data);
        axios
          .post(`${apiBaseUrl}/visitor`, formData, {
            headers: {
              "Content-Type": "application/json",
            },
          })
          .then((res) => {
            console.log("res is ", res);
          })
          .catch((err) => {
            console.log("err is ", err);
          });
      });
  };
  useEffect(() => {
    const lang = localStorage.getItem("lang");
    if (lang) setSelectedLanguag(lang);
    document.documentElement.dir = lang === "AR" ? "rtl" : "ltr";
    getUserData();
  }, []);
  return (
    <AuthContext.Provider
      value={{
        currentLanguage: selectedLanguage,
        changeLanguage: changeLanguage,
      }}
    >
      <Router>
        <Switch>
          <Route path="/" exact>
            <LandPage />
          </Route>
          <Route path="/more" exact>
            <More />
          </Route>
          <Route path="/project/:id" exact>
            <Project />
          </Route>
          <Route path="/news/:id" exact>
            <NewDetail />
          </Route>
          <Redirect to="/" />
        </Switch>
      </Router>
    </AuthContext.Provider>
  );
}

export default App;
